import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { heroTitle1, heroTitle2, heroSubtitle, ctaSheet, ctaBuy, trustBadges } from "@/mocks/content";

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background image right side */}
      <div className="absolute right-0 top-0 w-full lg:w-1/2 h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Diagonal%20artistic%20arrangement%20of%20premium%20fashion%20sneakers%20with%20reflective%20metallic%20accents%20a%20textured%20knit%20sweater%20and%20a%20sleek%20crossbody%20bag%20scattered%20across%20a%20warm%20sandstone%20surface%20with%20natural%20sunlight%20streaming%20diagonally%20creating%20elongated%20soft%20shadows%20modern%20luxury%20editorial%20composition%20with%20clean%20negative%20space%20and%20gentle%20warm%20amber%20undertones&width=1440&height=900&seq=hero-main-bg-v2-02&orientation=landscape"
          alt="AllChinaBuy Spreadsheet product directory flat lay photography"
          title="AllChinaBuy Spreadsheet Directory Products"
          className="w-full h-full object-cover object-top hidden lg:block"
          loading="eager"
        />
      </div>

      {/* Dark overlay for right side on desktop */}
      <div className="absolute right-0 top-0 w-full lg:w-1/2 h-full bg-gradient-to-r from-transparent via-transparent to-black/10 hidden lg:block"></div>

      {/* Left content */}
      <div className="relative z-10 w-full lg:w-1/2 px-4 md:px-6 lg:px-12 xl:px-20 py-20 md:py-28">
        <div className="bg-background-100/90 lg:bg-transparent rounded-2xl lg:rounded-none p-8 md:p-10 lg:p-0">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.15] text-foreground-950 mb-5">
            <span className="block">{heroTitle1}</span>
            <span className="block italic font-normal text-foreground-800">{heroTitle2}</span>
          </h1>

          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-lg">
            {heroSubtitle}
          </p>

          {/* Main CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-start gap-4 mb-10">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold uppercase tracking-wider hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              {ctaSheet}
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-primary-500 text-primary-500 rounded-full text-sm font-semibold uppercase tracking-wider hover:bg-primary-500 hover:text-background-50 transition-all whitespace-nowrap cursor-pointer"
            >
              {ctaBuy}
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-3 mb-10">
            {trustBadges.map((badge) => (
              <span
                key={badge}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-accent-50 text-accent-800 rounded-full text-xs font-medium whitespace-nowrap"
              >
                <i className="ri-check-line w-3 h-3 flex items-center justify-center"></i>
                {badge}
              </span>
            ))}
          </div>

          {/* Category Quick Buttons */}
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 bg-background-50 border border-foreground-200/40 rounded-lg text-xs font-medium text-foreground-700 hover:border-foreground-400 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}